import { render, staticRenderFns } from "./signuUpOngoingExportFull.vue?vue&type=template&id=4882fa2a&lang=pug"
import script from "./signuUpOngoingExportFull.vue?vue&type=script&lang=js"
export * from "./signuUpOngoingExportFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports